import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Zap, Ruler, Shield, Clock, CheckCircle2, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { prestressedConcreteContent } from '../../data/mock';

const PrestressedConcretePage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-[#242726]">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="caption text-[#c4291c] mb-4 block">Technologie</span>
              <h1 className="heading-1 text-white mb-6">
                {prestressedConcreteContent.title}
              </h1>
              <p className="body-large text-white/70">
                {prestressedConcreteContent.subtitle}
              </p>
            </div>
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src={prestressedConcreteContent.image}
                  alt="Prestressed Concrete"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What is Prestressed Concrete */}
      <section className="section-padding bg-[#1a1c1b]">
        <div className="container-custom">
          <div className="max-w-3xl">
            {prestressedConcreteContent.sections.slice(0, 2).map((section, index) => (
              <div key={index} className="mb-12">
                <h2 className="heading-2 text-white mb-6">{section.title}</h2>
                <p className="body-large text-white/70">{section.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PREBATI Process */}
      <section className="section-padding bg-[#242726]">
        <div className="container-custom">
          <div className="text-center mb-16">
            <span className="caption text-[#c4291c] mb-4 block">Processus</span>
            <h2 className="heading-1 text-white mb-6">
              {prestressedConcreteContent.sections[2].title}
            </h2>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="relative">
              {/* Vertical line */}
              <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-white/10 hidden md:block" />

              <div className="space-y-8">
                {prestressedConcreteContent.sections[2].steps.map((step, index) => (
                  <div key={index} className="flex gap-6 items-start">
                    <div className="w-12 h-12 rounded-full bg-[#c4291c] flex items-center justify-center flex-shrink-0 relative z-10">
                      <span className="text-white font-bold">{index + 1}</span>
                    </div>
                    <div className="bg-[#1a1c1b] rounded-xl p-6 flex-1 border border-white/10">
                      <p className="text-white body-large">{step}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="section-padding bg-[#1a1c1b]">
        <div className="container-custom">
          <div className="text-center mb-16">
            <span className="caption text-[#c4291c] mb-4 block">Avantages</span>
            <h2 className="heading-1 text-white mb-6">
              Les bénéfices du béton précontraint
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {prestressedConcreteContent.benefits.map((benefit, index) => {
              const icons = [Zap, Ruler, Shield, Clock];
              const Icon = icons[index];
              return (
                <div
                  key={index}
                  className="bg-[#2a2d2c] rounded-2xl p-8 border border-white/10 card-hover"
                >
                  <div className="w-14 h-14 rounded-2xl bg-[#c4291c]/10 flex items-center justify-center mb-6">
                    <Icon className="w-7 h-7 text-[#c4291c]" />
                  </div>
                  <h3 className="heading-3 text-white mb-3">{benefit.title}</h3>
                  <p className="text-white/60 body-medium">{benefit.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Comparison Teaser */}
      <section className="py-16 bg-[#242726] border-y border-white/10">
        <div className="container-custom">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h3 className="heading-3 text-white mb-2">
                Béton précontraint vs construction traditionnelle
              </h3>
              <p className="text-white/60 body-medium">
                Découvrez pourquoi le précontraint est plus avantageux.
              </p>
            </div>
            <Link to="/comparison">
              <Button className="btn-secondary">
                Voir le comparatif
                <ChevronRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Learn More Section */}
      <section className="section-padding bg-[#1a1c1b]">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="heading-2 text-white mb-4">
              Approfondir vos connaissances
            </h2>
            <p className="text-white/60 body-large">
              Consultez nos articles pour en savoir plus sur le béton précontraint.
            </p>
          </div>
          <div className="flex justify-center gap-4 flex-wrap">
            <Link to="/articles">
              <Button className="btn-secondary">
                Lire nos articles
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
            <a href="https://wa.me/22243111616?text=" target="_blank" rel="noopener noreferrer">
              <Button className="btn-primary">
                Demander un devis
                <ArrowRight className="w-4 h-4" />
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrestressedConcretePage;
